import * as React from 'react'

const Playlist =()=>{
    return(
        <h1>Your Saved Song</h1>
    )
}

export default Playlist